import { onUnmounted } from 'vue';
import { useTask } from '@/ui/concerns';
import { get as getTemplate } from '@/services/api/resources/template/actions';
import { useTemplateLibraryStore } from '@/stores/checklist/templateLibrary';

export function useTemplateList() {
  const store = useTemplateLibraryStore();
  const getTemplateTask = useTask(
    (id: number | undefined) => getTemplate(id as number),
    templateResponse => {
      store.setActiveTemplate(templateResponse.data.data);
    },
  );

  const setActiveTemplate = (templateId: number) => {
    getTemplateTask.run(templateId);
  };

  onUnmounted(() => {
    store.setActiveTemplate(null);
  });

  return {
    setActiveTemplate,
  };
}
